import * as Sentry from "@sentry/browser";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { createRoot } from "react-dom/client";
import App from "./App";

dayjs.extend(utc);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || "development",
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "TypeError: NetworkError when attempting to fetch resource.",
      "Failed to fetch",
      "Invalid Token",
    ],
    release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
  });
  Sentry.setTag("CI_COMMIT_SHORT_SHA", import.meta.env.VITE_CI_COMMIT_SHORT_SHA);
}
const hashElement = document.getElementById("hash");
if (hashElement) {
  hashElement.innerText = import.meta.env.VITE_CI_COMMIT_SHORT_SHA || "";
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
